import React from "react";
import { PackageSearch } from "lucide-react";
import { c, EmptyBody, EmptyBox, EmptyIcon, EmptyTitle, StatBox, StatLabel, StatValue } from "./styles";

interface StatProps {
    label: string;
    value: number;
}

export function Stat({ label, value }: StatProps) {
    return (
        <StatBox>
            <StatValue>{value}</StatValue>
            <StatLabel>{label}</StatLabel>
        </StatBox>
    );
}

interface EmptyStateProps {
    title: string;
    body: string;
}

export function EmptyState({ title, body }: EmptyStateProps) {
    return (
        <EmptyBox>
            <EmptyIcon>
                <PackageSearch size={20} color={c.slate400} />
            </EmptyIcon>
            <EmptyTitle>{title}</EmptyTitle>
            <EmptyBody>{body}</EmptyBody>
        </EmptyBox>
    );
}
